export const LayoutRowContainerClass: string =
  'max-w-4xl mx-auto space-x-2 px-2 md:px-4';

// tailwind small cap font
export const SmallCap = ({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <span
      className={`text-xs font-semibold uppercase tracking-wide text-fg-4 ${className}`}
      style={{ fontFamily: 'var(--font-zalando-sans-narrow)' }}
    >
      {children}
    </span>
  );
};
